/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycFinalObservationsDto } from '../../models/kyc-final-observations-dto';

export interface SaveFinalObservations$Params {
  processId: string;
      body: KycFinalObservationsDto
}

export function saveFinalObservations(http: HttpClient, rootUrl: string, params: SaveFinalObservations$Params, context?: HttpContext): Observable<StrictHttpResponse<KycFinalObservationsDto>> {
  const rb = new RequestBuilder(rootUrl, saveFinalObservations.PATH, 'put');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycFinalObservationsDto>;
    })
  );
}

saveFinalObservations.PATH = '/kyc/processes/{processId}/final-observations';
